<template>
  <panel-layout
    id="panel"
    :loading="waitlist.loading"
    :heading="heading"
    :show-footer="false"
  >
    <template #actions-right>
      <segment-field v-model="filter" :options="filterOptions" class="mr-2" />
    </template>

    <div class="h-full flex flex-col">
      <o-scroll v-if="waitlist" class="p-5">
        <!--<waitlist
          v-for="item in waitlist.items"
          :key="item.idWaitlist"
          :waitlist="item"
        />-->

        <div v-for="item in waitlist.items" :key="item.idWaitlist" class="grid grid-cols-2 gap-4 p-2 border rounded bg-gray-50 dark:bg-gray-800/20 dark:border-gray-800 mb-3">
          <div>
            <p class="text-sm font-semibold leading-tight md:leading-loose line-clamp-1 mb-1">
              {{ item.customer.displayName }}
            </p>

            <p class="text-sm text-gray-700 dark:text-gray-200">
              {{ item.servicesLabel }} with {{ item.employeesLabel }}
            </p>

            <div class="flex items-center flex-wrap mt-1">
              <template v-for="i in 3" :key="i">
                <p v-if="item.datesLabel[i - 1]" class="text-xs p-1 bg-gray-200/60 dark:bg-gray-800/20 rounded-md mb-1 mr-1">
                  {{ item.datesLabel[i - 1] }}
                </p>
              </template>
              <template v-if="item.datesLabel.length > 3">
                <o-tooltip :text="item.datesLabel.join(', ')">
                  <p  class="text-xs p-1 px-2 bg-gray-200/60 dark:bg-gray-800/20 rounded-md mr-1 mb-1">
                  {{ $t('waitlist.andMore', { count: item.datesLabel.length - 3 }) }}
                </p>
                </o-tooltip>
              </template>
            </div>
          </div>

          <div class="flex items-center justify-end flex-wrap space-x-2">
            <o-chip v-if="item.status" :variant="item.statusColour" flat size="xs">
              {{ $t(WaitlistStatusLabels[item.status as WaitlistStatus]) }}
            </o-chip>

            <o-panel-link :path="`/waitlist/${item.idWaitlist}`" tag="o-button" flat size="sm" icon="edit" />
          </div>
        </div>

        <p v-if="!waitlist.items.length" class="text-sm text-gray-700 dark:text-gray-200">
          {{ $t('pages.waitlist.index.noRequests') }}
        </p>
      </o-scroll>

      <div>
        <o-pagination v-if="waitlist" v-model:pager="waitlist" container-class="py-3 border-t flex justify-between items-center flex-shrink-0 px-4" />
      </div>
    </div>

    <!--<o-panel-link
        v-if="!waitlist.isExpired"
        tag="o-button"
        path="/appointment/create"
        size="sm"
        class="flex-shrink-0"
        :props="props"
      >
        Create booking
      </o-panel-link>-->
  </panel-layout>
</template>
<script setup lang="ts">
import {
  TablePager,
} from '@/_api/lib/pager'

// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import { WaitlistStatus, WaitlistStatusLabels } from '~/_api/models/waitlist'

// @ts-ignore
import Waitlist from '@/components/waitlist/elements/Preview.vue'

// @ts-ignore
import {
  OPagination,
} from '@/components/elements'

// @ts-ignore
import {
  SegmentField,
} from '@/components/fields'

import { usePanel } from '~/composables/usePanel'

const panel = usePanel()

const { $api, $i18n } = useNuxtApp()

const filter = ref('active')
const page = ref(1)
const waitlist = ref<any>(new TablePager((page: any) => $api.waitlist.filtered({ page, filter: filter.value }), 100))

const filterOptions = [
  {
    label: $i18n.t('general.active'),
    value: 'active',
  },
  {
    label: $i18n.t('waitlist.booked'),
    value: 'booked',
  },
  {
    label: $i18n.t('general.expired'),
    value: 'inactive',
  },
]

const heading = computed(() => $i18n.t('general.waitlist'))

watch(filter, () => {
  waitlist.value.reload()
})

onMounted(() => {
  waitlist.value.load()
})
</script>
